let allChallenges = []
let challengePage = 1
const challengePageSize = $(window).width() < 560 ? 4 : 8
let totalChallengePages = 1
const $pagination = $('#pagination-earn-list')
const defaultOpts = {
  visiblePages: 3,
  totalPages: 1,
  first: `<i><svg width="12" height="11" viewBox="0 0 12 11" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.7598 0.205025L0.305025 4.6598C0.0316582 4.93317 0.0316582 5.37638 0.305025 5.64975L4.7598 10.1045C5.03316 10.3779 5.47638 10.3779 5.74975 10.1045C6.02311 9.83115 6.02311 9.38794 5.74975 9.11457L2.48995 5.85477H10.8C11.1866 5.85477 11.5 5.54137 11.5 5.15477C11.5 4.76817 11.1866 4.45477 10.8 4.45477H2.48995L5.74975 1.19497C6.02311 0.921608 6.02311 0.478393 5.74975 0.205025C5.47638 -0.0683417 5.03316 -0.0683417 4.7598 0.205025Z"/>
    </svg>
    </i>`,
  last: `<i><svg width="12" height="11" viewBox="0 0 12 11" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.2402 0.205025L11.695 4.6598C11.9683 4.93317 11.9683 5.37638 11.695 5.64975L7.2402 10.1045C6.96684 10.3779 6.52362 10.3779 6.25025 10.1045C5.97689 9.83115 5.97689 9.38794 6.25025 9.11457L9.51005 5.85477H1.2C0.813401 5.85477 0.5 5.54137 0.5 5.15477C0.5 4.76817 0.813401 4.45477 1.2 4.45477H9.51005L6.25025 1.19497C5.97689 0.921608 5.97689 0.478393 6.25025 0.205025C6.52362 -0.0683417 6.96684 -0.0683417 7.2402 0.205025Z"/>
    </svg>
    </i>`,
  onPageClick: function (event, currentPage) {
    if (currentPage !== challengePage) {
      renderChallenges(currentPage);
      challengePage = currentPage;
    }
  }
};
const LOYALTY_BASE_URL = 'https://d32q88jremacgy.cloudfront.net/loyalty'
const LOYALTY_REWARDS = [
  {
    title: '10% OFF',
    description: 'Need 500 Points to activate',
  },
  {
    title: '15% OFF',
    description: 'Need 600 Points to activate',
  },
  {
    title: '20% OFF',
    description: 'Need 800 Points to activate, min spend $50',
  },
  {
    title: '5 USD',
    description: 'Need 500 Points to activate',
  },
  {
    title: '10 USD',
    description: 'Need 1000 points, min spend $55',
  },
  {
    title: '15 USD',
    description: 'Need 1500 points, min spend $60',
  },
];
const LOYALTY_TIERS = [
  {
    title: 'Silver',
    description: 'Starts at 0 USD',
    bgColor: '#FCF5EE',
    color: '#000',
    benefits: [
      {
        label: 'Begin Your Exclusive Journey'
      }
    ]
  },
  {
    title: 'Gold',
    description: 'Starts at 90 USD',
    bgColor: '#FBD1A5',
    color: '#000',
    benefits: [
      {
        label: 'Entry Reward:',
        value: '10% discount'
      }
    ]
  },
  {
    title: 'Platinum',
    description: 'Starts at 150 USD',
    bgColor: '#F3834A',
    color: '#fff',
    benefits: [
      {
        label: 'Entry Reward:',
        value: '15% discount'
      }
    ]
  },
  {
    title: 'Diamond',
    description: 'Starts at 250 USD',
    bgColor: '#D85A1B',
    color: '#fff',
    benefits: [
      {
        label: 'Entry Reward:',
        value: '20% discount'
      },
      {
        label: 'Lifetime Reward:',
        value: '5% discount'
      }
    ]
  },
  {
    title: 'VVIP',
    description: 'Starts at 500 USD',
    bgColor: '#F13C20',
    color: '#fff',
    benefits: [
      {
        label: 'Entry Reward:',
        value: '25% discount'
      },
      {
        label: 'Lifetime Reward:',
        value: '10% discount'
      }
    ]
  },
];

async function getCustomerBalance() {
  return fetch(`${LOYALTY_BASE_URL}/player/${loyaltyCustomerId}`).then(res => res.json())
}

async function getCustomerChallenges() {
  return fetch(`${LOYALTY_BASE_URL}/player/${loyaltyCustomerId}/progress`).then(res => res.json())
}

async function getLoyaltyChallenges() {
  return fetch(`${LOYALTY_BASE_URL}/config/challenge`).then(res => res.json())
}

async function renderCurrentProgress() {
  const customerInfo = await getCustomerBalance()
  if (customerInfo) {
    $('.customer-points').text(customerInfo?.balance?.pointsBalance?.toLocaleString() || 0)
    $('.loyalty-status-wrapper .progress-bar').css({ width: `${customerInfo?.level?.levelOrder * 20}%` })
    $('.loyalty-status-wrapper .dot-info').removeClass('active')
    $('.loyalty-status-wrapper .dot-info').each(function (index) {
      if (index < customerInfo?.level?.levelOrder - 1) {
        $(this).addClass('active');
        $(this).find('.label').text('');
      } else if (index === customerInfo?.level?.levelOrder - 1) {
        $(this).addClass('active');
        $(this).find('.label').text('You are here');
      }
    })
  }
}

function renderRewards() {
  $('.loyalty-reward-list').html(
    LOYALTY_REWARDS.map(reward => (
      `
        <a href="#gameball-redemption" class="loyalty-reward-item">
          <p class="loyalty-reward-item__title">${reward.title}</p>
          <p class="loyalty-reward-item__description">${reward.description}</p>
        </a>
      `
    )).join('')
  )
}

function renderChallenges(currentPage) {
  const displayChallenge = allChallenges.slice((currentPage - 1) * challengePageSize, currentPage * challengePageSize)
  $('.loyalty-earn-list').html(
    displayChallenge.map(challenge => (
      `
        <a href="#gameball-home" class="loyalty-earn-item">
          ${
            challenge.completionPercentage === 100 ? (
              `<div class="loyalty-earn-item__done">Done</div>`
            ) : ''
          }
          <img class="loyalty-earn-item__icon" src="${challenge.icon}" />
          <p class="loyalty-earn-item__title">${challenge.name}</p>
          <p class="loyalty-earn-item__rewards">
            ${
              challenge.rewards.map(reward => {
                const rewardLength = challenge.rewards.length
                if (reward.walletReward > 0) {
                  return `<span>${rewardLength > 1 ? 'Customer ' : ''}${reward.walletReward} points</span>`
                } else if (reward.rankReward) {
                  return `<span>${reward.rankReward} rank</span>`
                } else if (reward.couponReward) {
                  const { couponType, discountValue } = reward.couponReward
                  return `<span>${rewardLength > 1 ? 'Friends ' : ''}${couponType === 'Fixed' && '$'}${discountValue} OFF</span>`
                }
                return ''
              }).join(' - ')
            }
          </p>
        </a>
      `
    )).join('')
  )
  // $('.loyalty-earn-list').css({ 'min-height': $('.loyalty-earn-list').height() })
  $('.loyalty-earn-item').click(function(e) {
    e.preventDefault()
    window.location.href = "#gameball-home"
  })
}

function renderChallengePaginate() {
  const numberOfPage = Math.ceil(allChallenges.length/challengePageSize) || 1
  $pagination.twbsPagination('destroy');
  $pagination.twbsPagination({
    ...defaultOpts,
    startPage: Number(challengePage),
    totalPages: numberOfPage
  });
}

async function renderEarns() {
  let challenges
  if (loyaltyCustomerId) {
    const challengesProgress = await getCustomerChallenges()
    if (challengesProgress?.challengesProgress) {
      challenges = challengesProgress.challengesProgress.map(item => ({...item.challengeConfig, completionPercentage: item.completionPercentage}))
    }
  } else {
    const challengesProgress = await getLoyaltyChallenges()
    if (challengesProgress?.challenges) challenges = challengesProgress.challenges
  }
  if (challenges && challenges.length) {
    allChallenges = challenges
    renderChallenges(challengePage)
    renderChallengePaginate()
  }
}

function renderTiers() {
  $('.loyalty-tier-list').html(
    LOYALTY_TIERS.map(tier => (
      `
        <a href="#gameball-levels" class="loyalty-tier-item">
          <div class="loyalty-tier-item__header" style="background-color: ${tier.bgColor}; color: ${tier.color}">
            <p class="loyalty-tier-item__title">${tier.title}</p>
            <p class="loyalty-tier-item__description">${tier.description}</p>
          </div>
          <div class="loyalty-tier-item__body">
            ${
              tier.benefits.map(benefit => (
                `<div class="loyalty-tier-item__body--item">
                  <span class="loyalty-tier-item__body--item-label">${benefit.label}</span>
                  <strong class="loyalty-tier-item__body--item-value">${benefit.value || ''}</strong>
                </div>`
              )).join('')
            }
          </div>
        </a>
      `
    )).join('')  
  )
}

$("document").ready(function() {
  if (loyaltyCustomerId) {
    renderCurrentProgress()
  }
  renderRewards()
  renderEarns()
  renderTiers()

  $(document).on("click",".faq-headline",function(e){
    e.preventDefault();
    if ($(this).hasClass('active')) {
      $('.faq-headline').removeClass('active');
      $('.loyalty-faq .panel').removeClass('show');
    } else {
      $('.faq-headline').removeClass('active');
      $('.loyalty-faq .panel').removeClass('show');
      $(this).addClass('active');
      $(this).next().addClass('show');
    }
  });
})
